import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useApp } from '../contexts/AppContext';
import AppLoadingScreen from './AppLoadingScreen';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { state } = useApp();
  const location = useLocation();

  if (state.isAuthenticating) {
    return <AppLoadingScreen />;
  }

  if (!state.user) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  // Check if user needs to complete profile (only for authenticated users)
  if (!state.user.profile_completed) {
    return <Navigate to="/complete-profile" replace />;
  }

  // Check if user needs to confirm email (only after profile is completed)
  if (!state.user.confirmed_email_at) {
    return <Navigate to="/check-your-email" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
